import Form from './form'
import { moveWorkoutDetailPromise } from 'api/MoveWorkout'
import React, { useMemo, useState } from 'react'

export default function CourseAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    moveWorkoutDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form mode='edit' data={data} setData={setData} {...props} />
}